import { PaginationFilterRequest } from '../Types';
import { useSearchParams } from './useSearchParams';

export const usePagination = (value?: PaginationFilterRequest) => {
    const initialValues: PaginationFilterRequest = {
        page: 1,
        pageSize: 20,
        useCountTotal: 'true',
        orderBy: 'id',
        orderDirection: 'desc',
        search: '',
        ...value
    };

    return useSearchParams<PaginationFilterRequest>(initialValues, [
        'page',
        'pageSize',
        'orderBy',
        'orderDirection',
        'search',
        'useCountTotal'
    ]);
};
